var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{ref:"textarea",staticClass:"w-full form-input form-input-bordered py-2",attrs:{"rows":"1","placeholder":_vm.$t('Enter text')},domProps:{"value":_vm.item.response},on:{"change":_vm.handleInput,"keyup":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }